/**
 * What removing a competitor actually does, stated where it is done.
 *
 * This is the honesty the engine's module docstring carries, put in front of
 * the person acting on it. Each sentence answers a question somebody would
 * otherwise be right to ask -- and the fastest-lap one admits something the
 * project cannot know.
 */
export function RemovalNotice() {
  return (
    <div className="notice">
      <p>
        <strong>Removing a competitor reclassifies every race.</strong> Everyone who finished
        behind them gains a place and scores the points for their new position.
      </p>
      <p>
        The fastest-lap point they set is <strong>not</strong> re-awarded: who would have set it
        instead cannot be known from the record.
      </p>
      <p>Removing a constructor also removes its drivers’ results for that season.</p>
      <p>
        Because positions change, points are recomputed from the points table rather than
        replayed from the record.
      </p>
    </div>
  )
}
